import { useState, useRef, useCallback, useEffect } from 'react';

export function useFileUpload({ initialPreview = null, validator, onPreview, onFileChange }) {
    const [fileName, setFileName] = useState('');
    const [preview, setPreview] = useState(initialPreview);
    const [error, setError] = useState('');
    const inputRef = useRef(null);

    // Sync preview if initialPreview changes after mount
    useEffect(() => {
        setPreview(initialPreview);
        setFileName(initialPreview);
    }, [initialPreview]);

    const handleFileChange = useCallback((e) => {
        const file = e.target.files[0];
        if (!file) return;
        const validationError = validator(file);
        if (validationError) {
            setError(validationError);
            setFileName('');
            setPreview(initialPreview);
        } else {
            setError('');
            setFileName(file.name);
            if (onPreview) onPreview(file, setPreview);
            if (onFileChange) onFileChange(file);
        }
        // allow re-selecting same file
        e.target.value = '';
    }, [validator, onPreview, onFileChange, initialPreview]);

    return { fileName, preview, error, inputRef, handleFileChange };
}